import React from 'react';
import { bool } from 'prop-types';
import { compose } from 'redux';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import { Field, Form as FinalForm } from 'react-final-form';
import {
  Form,
  IconEmailAttention,
  IconEmailSuccess,
  NamedLink,
  PrimaryButton,
} from '../../components';
import { propTypes } from '../../util/types';
import classNames from 'classnames';
import SignUpField from '../SignupForm/SignUpField';

import css from './EmailVerificationForm.css';

const EmailVerificationFormComponent = props => (
  <FinalForm
    {...props}
    render={formRenderProps => {
      const { currentUser, inProgress, handleSubmit, verificationError,
        intl, formId, values, form } = formRenderProps;

      const { email, emailVerified, pendingEmail, profile } = currentUser.attributes;
      const emailToVerify = <strong>{pendingEmail || email}</strong>;
      const name = profile.firstName;

      const errorMessage = (
        <div className={css.error}>
          <FormattedMessage id="EmailVerificationForm.verificationFailed" />
        </div>
      );

      const submitInProgress = inProgress;
      const submitDisabled = submitInProgress || form.getState().invalid;
      const isGeneratedUser = currentUser && currentUser.attributes && currentUser.attributes.profile.privateData && currentUser.attributes.profile.privateData.isGenerated;

      const verifyEmail = (
        <div className={css.root}>
          <div>
            <IconEmailAttention className={classNames(css.invisible, css.modalIcon)} />
            <h1 className={css.modalTitle}>
              {isGeneratedUser ?
                <FormattedMessage id="EmailVerificationForm.verifyGeneratedUser" values={{ name: name }} /> :
                <FormattedMessage id="EmailVerificationForm.verifyEmailAddress" />
              }
            </h1>

            <p className={css.modalMessage}>
              {isGeneratedUser ?
                <FormattedMessage
                  id="EmailVerificationForm.finishGeneratedAccountSetup"
                  values={{ email: emailToVerify }}
                /> :
                <FormattedMessage
                  id="EmailVerificationForm.finishAccountSetup"
                  values={{ email: emailToVerify }}
                />
              }
            </p>

            {verificationError ? errorMessage : null}
          </div>

          <Form onSubmit={handleSubmit}>
            <Field component="input" type="hidden" name="verificationToken" />
            {isGeneratedUser &&
              <div>
                <SignUpField intl={intl} formId={formId} values={values} />
              </div>
            }
            <div className={css.bottomWrapper}>
              <PrimaryButton type="submit" inProgress={submitInProgress} disabled={true}>
                <FormattedMessage id="EmailVerificationForm.verifying" />
              </PrimaryButton>
            </div>
          </Form>
        </div>
      );

      const alreadyVerified = (
        <div className={css.root}>
          <div>
            <IconEmailSuccess className={classNames(css.invisible, css.modalIcon)} />
            <h1 className={css.modalTitle}>
              <FormattedMessage id="EmailVerificationForm.successTitle" values={{ name }} />
            </h1>

            <p className={css.modalMessage}>
              <FormattedMessage id="EmailVerificationForm.successText" />
            </p>
          </div>

          <div className={css.bottomWrapper}>
            <NamedLink className={css.submitButton} name="LandingPage">
              <FormattedMessage id="EmailVerificationForm.successButtonText" />
            </NamedLink>
          </div>
        </div>
      );

      return emailVerified && !pendingEmail ? alreadyVerified : verifyEmail;
    }}
  />
);

EmailVerificationFormComponent.defaultProps = {
  currentUser: null,
  inProgress: false,
  verificationError: null,
};

EmailVerificationFormComponent.propTypes = {
  inProgress: bool,
  currentUser: propTypes.currentUser.isRequired,
  verificationError: propTypes.error,
};

const EmailVerificationForm = compose(injectIntl)(EmailVerificationFormComponent);

export default EmailVerificationForm;
